import React, { useMemo } from 'react';
import { X } from 'lucide-react';
import classNames from 'classnames';
import commentToHtml from '../utils/commentToHtml';
import commentCreatedAt from '../utils/commentCreatedAt';
import CommentAvatar from './comment-avatar';
import CommentRoleLabelComponent from './comment-role-label';
import Button from '../../../components/Button';

export default function CommentInputEditComponent({
  comment,
  comment: {
    message,
    createdAt,
    sender,
    sender: { id, image },
  },
  currentUserId,
  members = [],
  onEditCancel = () => {},
}) {
  const resultMessage = useMemo(() => {
    return commentToHtml(message, members, id);
  }, [message, members]);

  return (
    <div className="comment-item">
      <div className="comment-item-header">
        <div className="comment-item-header-avatar">
          <CommentAvatar url={image?.icon?.url} />
        </div>
        <div className="comment-item-header-sender">
          <div
            className={classNames('comment-item-header-sender__full-name', {
              'text-muted-darker': comment?.sender?.isDeleted,
            })}
          >
            {comment?.sender?.firstName} {comment?.sender?.surname}
          </div>
          <CommentRoleLabelComponent
            sender={sender}
            currentUserId={currentUserId}
          />
        </div>
        <Button variant="ghost" size="evenDefault" onClick={onEditCancel}>
          <X />
        </Button>
      </div>
      <div className="comment-item-content">
        <div className="comment-item-content__line" />

        <div className="comment-item-message">
          <div
            className="comment-item-message__text"
            dangerouslySetInnerHTML={{ __html: resultMessage }}
          />
        </div>
        <div className="comment-item-message__created-at">
          {commentCreatedAt(createdAt)}
        </div>
      </div>
    </div>
  );
}
